<template>
  <div id="sec-voucher" class="pb-3 mb-4">
    <div class="px-3">
      <div class="ch-section-header mb-3">
        <h2 class="heading-6-1 mb-0" style="letter-spacing:-0.3px">{{ upg.name }}</h2>
      </div>

      <!-- Featured banner -->
      <button
        @click="$emit('navigate', targetRoute)"
        class="ch-featured-banner w-100 radius-16 overflow-hidden mb-3 p-0"
        :style="{ backgroundImage: bannerImage }"
        type="button"
      >
        <div class="ch-featured-overlay">
          <span class="ch-btn-primary px-3 py-2 d-inline-flex align-items-center rounded-50 text-12 font-bold ls-0-25">
            Explore <i class="simple-icon-arrow-right ml-1" style="font-size:10px"></i>
          </span>
        </div>
      </button>
    </div>

    <!-- Product cards -->
    <template v-if="products.length > 0">
      <div class="ch-hscroll px-3">
        <div
          v-for="product in products"
          @click="$emit('navigate', targetRoute)"
          class="ch-voucher-card radius-16 bg-white flex-shrink-0"
        >
          <img :src="product.cover_image_url || ''" class="ch-voucher-img-el" alt="" />
          <div class="p-3">
            <p class="mb-0 text-15 lh-1-3 font-bold text-truncate">{{ product.name }}</p>
            <p v-if="product.description" class="mb-1 color-grey text-11 lh-1-5 font-regular ch-product-desc" v-html="product.description"></p>
            <p class="mb-0 font-lato text-14 mt-2" style="color:var(--merchant-text-color)">{{ formatCurrency(product.price.price_sell) }}</p>
          </div>
        </div>
      </div>
      <div class="px-3 pt-3 text-center">
        <span
          @click="$emit('navigate', targetRoute)"
          class="ch-more-link text-13 font-bold cursor-pointer"
        >See all vouchers <i class="simple-icon-arrow-right" style="font-size:10px"></i></span>
      </div>
    </template>
  </div>
</template>

<script>
  import { formatCurrency } from '@/utils/index.js'

  export default {
    name: 'ConciergeVoucherSection',

    props: {
      items: { type: Array, default: function() { return [] } },
    },

    computed: {
      firstItem() {
        return this.items[0] || {}
      },

      upg() {
        return (this.firstItem.upselling_product_group) || {}
      },

      targetRoute() {
        return { name: 'GroupVoucher', params: { id: this.upg.id } }
      },

      bannerImage() {
        var slider = this.upg.slider || []
        return slider.length > 0 ? 'url(' + slider[0].image_url + ')' : 'none'
      },

      products() {
        var result = []
        for (var i = 0; i < this.items.length; i++) {
          var upg = (this.items[i].upselling_product_group) || {}
          var groups = upg.group || []
          for (var j = 0; j < groups.length; j++) {
            var prods = groups[j].product || []
            for (var k = 0; k < prods.length; k++) {
              result.push(prods[k])
              if (result.length >= 6) return result
            }
          }
        }
        return result
      },
    },

    methods: {
      formatCurrency,

      voucherPrice(product) {
        var price = product.price.price_sell_final
        return (price && price.parsedValue) ? price.parsedValue : 0
      },
    },
  }
</script>

<style scoped>
.ch-section-header { padding-top: 8px; }

.ch-btn-primary {
  background: var(--merchant-primary-color, #2B5F7A);
  color: #fff;
  border: none;
  cursor: pointer;
}

.ch-featured-banner {
  height: 160px;
  background-color: #C8D8E4;
  background-size: cover;
  background-position: center;
  cursor: pointer;
  border: none;
  position: relative;
  display: block;
}

.ch-featured-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 40px 16px 16px;
  background: linear-gradient(to bottom, transparent, rgba(15,30,50,0.5));
  display: flex;
  align-items: flex-end;
}

.ch-hscroll {
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  gap: 12px;
  padding-bottom: 4px;
}

.ch-hscroll::-webkit-scrollbar { display: none; }

.ch-voucher-card {
  flex: 0 0 180px;
  border: 1px solid #E0E8EF;
  box-shadow: 0 1px 2px rgba(15,30,50,0.04), 0 4px 14px rgba(15,30,50,0.06);
  overflow: hidden;
  cursor: pointer;
  color: #1C2B36;
}

.ch-voucher-img-el {
  width: 100%;
  height: 120px;
  object-fit: cover;
  display: block;
}

.ch-more-link {
  color: var(--merchant-primary-color, #2B5F7A);
}
.ch-product-desc {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/ConciergeVoucherSection.vue